<template>
    <div class="bg-white border">
        <div class="p-4">
            <field
                :title="$t('moulded-parts.configure.outside-corners')"
                >
                <input type="number" v-model="form.formteile.außenecken" >
            </field>

            <field
                class="mt-6"
                :title="$t('moulded-parts.configure.inside-corners')"
            >
                <input type="number" v-model="form.formteile.innenecken" >
            </field>

            <field
                class="mt-6"
                :title="$t('moulded-parts.configure.connectors')"
            >
                <input type="number" v-model="form.formteile.verbinder" >
            </field>

            <div>
            </div>
        </div>
    </div>
</template>

<script>
import Field from '@/components/Field'

export default {
    components: { Field },
    data: () => ({

    }),
    props: {
        form: Object
    },

    mounted() {
        console.log(this.form.summary.formteile.innenecken);
    },

    methods: {

    },
    computed: {

    },
}
</script>
